import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import Table from "./components/home/Table";
import Singlephase from './components/powerPage/singlephase';
import Threephase from './components/powerPage/threephase';
import Report from "./components/home/Report";
import Acmonitoring from "./components/home/Acmonitoring";
import Accontroling from "./components/home/Accontroling";
import Chart from "./components/home/Chart";

import './tailwind.css';


function App() {
  const getMode = () => {
    return JSON.parse(localStorage.getItem("mode"));
  };
  const [dark, setMode] = useState(getMode());

  useEffect(() => {
    localStorage.setItem("mode", JSON.stringify(dark));
  }, [dark]);

  return (
    <>
      <div className={dark ? "app" : "light"}>
        <Header dark={dark} setMode={setMode} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/table" element={<Table />} />
          <Route path="/singlephase" element={<Singlephase />} />
          <Route path="/threephase" element={<Threephase />} />
          <Route path="/report" element={<Report />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/Acmonitoring" element={<Acmonitoring />} />
          <Route path="/Accontroling" element={<Accontroling />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
